import { FC } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

type TagKey = "isLcc" | "isRefundable";

type TagConfig = {
  labelKey: string | null;
  color: string;
};

const JOURNEY_CARD_TAGS: Record<TagKey, Record<"true" | "false", TagConfig>> = {
  isLcc: {
    true: { labelKey: "Flights.listing.lowCost", color: "text-font-informative!" },
    false: { labelKey: null, color: "" },
  },
  isRefundable: {
    true: {
      labelKey: "Flights.listing.refundable",
      color: "text-font-success!",
    },
    false: {
      labelKey: "Flights.listing.nonRefundable",
      color: "text-font-danger!",
    },
  },
};

function transformTags(tags: Record<TagKey, boolean>): { labelKey: string; color: string }[] {
  return (Object.keys(JOURNEY_CARD_TAGS) as TagKey[]).flatMap((key) => {
    const config = JOURNEY_CARD_TAGS[key][String(tags[key]) as "true" | "false"];
    if (!config || !config.labelKey) return [];
    return [{ labelKey: config.labelKey, color: config.color }];
  });
}

const JourneyCardTags: FC<{ tags: Record<TagKey, boolean> }> = ({ tags }) => {
  const { t } = useTranslation();
  const resolvedTags = transformTags(tags);

  return (
    <div className="flex items-start gap-1">
      {resolvedTags.map(({ labelKey, color }) => (
        <div
          key={labelKey}
          className={classNames(
            "px-2! py-1! text-xs! border! border-current! rounded-sm! bg-background-default! whitespace-nowrap",
            color,
          )}
        >
          {t(labelKey)}
        </div>
      ))}
    </div>
  );
};

export default JourneyCardTags;
